
import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FeedbackCategoryTag } from "@/types/feedback";

interface CategorySelectProps {
  category: FeedbackCategoryTag;
  setCategory: (category: FeedbackCategoryTag) => void;
  disabled?: boolean;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
  category,
  setCategory,
  disabled = false,
}) => {
  return (
    <Select
      value={category || "none"}
      onValueChange={(value) => setCategory(value === "none" ? null : value as FeedbackCategoryTag)}
      disabled={disabled}
    >
      <SelectTrigger className="w-[130px] h-9">
        <SelectValue placeholder="Categorie" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Geen categorie</SelectItem>
        <SelectItem value="bug">Bug</SelectItem>
        <SelectItem value="idee">Idee</SelectItem>
        <SelectItem value="vraag">Vraag</SelectItem>
        <SelectItem value="algemeen">Algemeen</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default CategorySelect;
